import { gql } from "@apollo/client";

export const removeSchoolGroupsQuery = gql`
mutation removeSchoolGroupsQuery($schoolGroupIds: [String!]!) {
  removeSchoolGroups(schoolGroupIds: $schoolGroupIds) {
    success
  }
}
`;
